import { CarDetailsErrorCauses } from '../../_tools/errors/car-details';
import { CarListErrorCauses } from '../../_tools/errors/car-list';
import { ConfigErrorCauses } from '../../_tools/errors/config';
import { ErrorAction, Errors } from '../../_tools/types/function-output-type';
import { type TranslationsErrors } from './translations';

const enUS: TranslationsErrors = {
    actions: {
        [ErrorAction.NONE]: '',
        [ErrorAction.EXIT]: 'Hide error',
        [ErrorAction.HOME]: 'Go back to homepage',
        [ErrorAction.RELOAD]: 'Reload page',
    },
    default: {
        heading: 'Sorry, an error occured!',
        description: 'Please try again later.',
    },
    [Errors.API]: {
        webcalc: {
            heading: 'WebCALC-Error',
            description: 'Unfortunately, an error occurred when requesting the calculation data. Please try again later!',
        },
    },
    [Errors.CAR_DETAILS]: {
        [CarDetailsErrorCauses.ERROR]: {
            heading: 'Server error while getting vehicle',
            description: '',
        },
        [CarDetailsErrorCauses.NOT_FOUND]: {
            heading: 'Vehicle not found',
            description: '',
        },
    },
    [Errors.CAR_LIST]: {
        [CarDetailsErrorCauses.ERROR]: {
            heading: 'Server error while getting vehicle list',
            description: '',
        },
        [CarListErrorCauses.NO_RESULTS]: {
            heading: 'No vehicles found',
            description: '',
        },
    },
    [Errors.CONFIG]: {
        [ConfigErrorCauses.DISABLED]: {
            heading: 'AHD Fleet disabled',
            description: 'Are you the operator? Please contact the administrator.',
        },
        [ConfigErrorCauses.HOST_NOT_FOUND]: {
            heading: "The host could'nt be found",
            description: 'Please contact the customer support.',
        },
        [ConfigErrorCauses.MISSING_IDGROUP]: {
            heading: 'Field "idGroup" is missing in configuration',
            description: 'Please contact the customer support.',
        },
        [ConfigErrorCauses.MISSING_LEADSYSTEM]: {
            heading: 'Field "contactLeadSystem" is missing in configuration',
            description: 'Please contact the customer support.',
        },
        [ConfigErrorCauses.MISSING_LINKDISCLAIMER]: {
            heading: 'Field "linkDisclaimer" is missing in configuration',
            description: 'Please contact the customer support.',
        },
        [ConfigErrorCauses.MISSING_MAIL]: {
            heading: 'The contact mail adress is not configured.',
            description: 'Please contact the customer support.',
        },
    },
    [Errors.MODULE_DISABLED]: {
        heading: 'Sorry, this module "{0}" is not available right now!',
        description: 'Are you the operator? Please contact the administrator.',
    },
};

export default enUS;
